import CarpenterOutlinedIcon from '@mui/icons-material/CarpenterOutlined';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {type FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import CuttingConfirmationDialog from '@/components/ForestMassDetail/CuttingConfirmationDialog';
import EnterWeightDialog from '@/components/ForestMassDetail/EnterWeightDialog';
import type {ForestMass} from '@/domain/entities/ForestMass';
import type {CutForestMass} from '@/domain/entities/Op';

//TYPES
type Props = {
  forestMass: ForestMass;
  onCutForestMass: (domain: CutForestMass) => void;
};

const CuttingForm: FC<Props> = ({forestMass, onCutForestMass}) => {
  const {t} = useTranslation();

  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);

  const {isCut, realWeight} = forestMass;

  const handleChange = () => setDialogOpen(true);
  const handleCut = (realWeight?: number) => {
    onCutForestMass({
      forestMassUuid: forestMass.uuid,
      realWeight: realWeight || 0,
    });
  };

  return (
    <Stack direction="row" spacing={1} sx={{alignItems: 'flex-start'}}>
      <Button startIcon={<CarpenterOutlinedIcon />} variant="outlined" onClick={handleChange}>
        {isCut ? t('forestMass.enterWeight') : t('forestMass.cut')}
      </Button>
      {isDialogOpen &&
        (isCut ? (
          <EnterWeightDialog onClose={() => setDialogOpen(false)} onCutChange={handleCut} realWeight={realWeight} />
        ) : (
          <CuttingConfirmationDialog onClose={() => setDialogOpen(false)} onCutChange={handleCut} />
        ))}
    </Stack>
  );
};
export default CuttingForm;
